import { render, staticRenderFns } from "./policyTsft.vue?vue&type=template&id=5488db73"
import script from "./policyTsft.vue?vue&type=script&lang=js"
export * from "./policyTsft.vue?vue&type=script&lang=js"
import style0 from "./policyTsft.vue?vue&type=style&index=0&id=5488db73&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports